import React, {useState} from "react";
import PropTypes from "prop-types";
// Composants
import OfferChoices from "./OfferChoices";
// Containers
import OfferForm from "../../../containers/Modals/OfferModal/OfferForm";
import Checkout390 from "../../../containers/Modals/OfferModal/Stripe/Offer390/Checkout";
import Checkout589 from "../../../containers/Modals/OfferModal/Stripe/Offer600/Checkout";
import Checkout350 from "../../../containers/Modals/OfferModal/Stripe/Offer350/Checkout";
import Checkout49 from "../../../containers/Modals/OfferModal/Stripe/Offer49/Checkout";
import Checkout190 from "../../../containers/Modals/OfferModal/Stripe/Offer190/Checkout";

const OfferModal = ({
																				showOfferModal,
																				setShowOfferModal,
																				dataUser,
																				idExt,
																				setOpenFreeQuestionChatBot
																				}) => {

// Permet de changer le composants affiché en utilisant un Switch case écrit en JSX
// Switch case JSX s'écrit de cette manière : {{valeur à afficher}, [valeur à vérifier]}
const [step, setStep] = useState("offer-choices");


return (
<>
<div id="modalBg">
{{
"offer-choices":
// A l'ouverture de la modal on affiche les choix d'offres pour l'utilisateur
<OfferChoices dataUser={dataUser} setStep={setStep} setShowOfferModal={setShowOfferModal}
														idExt={idExt} setOpenFreeQuestionChatBot={setOpenFreeQuestionChatBot}/>,
"question-gratuite":
<div>
<h1>question grauite</h1>
<button onClick={() => setStep("offer-choices")}>retour</button>
</div>,
// Affichage du formulaire pour rentrer ses coordonnées
"offer-589":
<div id="modalBox">
<OfferForm step={step} setStep={setStep}/>
</div>,
"offer-49":
<div id="modalBox">
<OfferForm step={step} setStep={setStep}/>
</div>,
"offer-190":
<div id="modalBox">
<OfferForm step={step} setStep={setStep}/>
</div>,
"offer-350":
<div id={"modalBox"}>
<OfferForm step={step} setStep={setStep}/>
</div>,
"offer-390":
<div id="modalBox">
<OfferForm step={step} setStep={setStep}/>
</div>,
// Affichage de l'étape dédié au paiement pour l'offre à 390€ (avec coordonnées bancaire, code promo, etc)
"checkout-49":
<div id="modalBox">
<Checkout49 step={step} setStep={setStep}/>
</div>,
"checkout-190":
<div id="modalBox">
<Checkout190 step={step} setStep={setStep}/>
</div>,
"checkout-390":
<div id="modalBox">
<Checkout390 step={step} setStep={setStep}/>
</div>,
"checkout-350":
<div id="modalBox">
<Checkout350 step={step} setStep={setStep}/>
</div>,
"checkout-589":
<div id="modalBox">
<Checkout589 step={step} setStep={setStep}/>
</div>
}[step]}
<div className="backgroundModal" onClick={() => showOfferModal ? setShowOfferModal(false) : null}></div>
</div>
</>
);
};

OfferModal.propTypes = {
showOfferModal: PropTypes.bool,
setShowOfferModal: PropTypes.func,
dataUser: PropTypes.object,
idExt: PropTypes.string,
setOpenFreeQuestionChatBot: PropTypes.func
};

export default OfferModal;
